<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 bg-gradient-primary">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-12">
                <h1 class="display-3 text-white">
                  Pendataan E-SPTPD Pajak Mineral Bukan Logam Batuan
                  <span>Kabupaten Ketapang</span>
                </h1>
                <br />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <br />
    <br />
    <section class="section section-lg pt-lg-0">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid">
              <card class="border-0" shadow body-classes="py-5">
                <b-row>
                  <b-col lg="12" class="my-1">
                    <div class="btn-wrapper float-right">
                      <base-button
                        tag="a"
                        class="mb-3 mb-sm-0"
                        type="info"
                        textColor="white"
                        icon="fa fa-arrow-left"
                        @click="goback()"
                      >Kembali</base-button>
                      <base-button
                        tag="a"
                        class="mb-3 mb-sm-0"
                        type="success"
                        textColor="white"
                        icon="fa fa-plus"
                        @click="newRegister()"
                      >Tambah</base-button>
                      <br />
                      <br />
                    </div>
                  </b-col>
                  <b-col lg="6">
                    <b-form-group
                      label="Filter"
                      label-for="filter-input"
                      label-cols-sm="2"
                      label-align-sm="right"
                      label-size="sm"
                    >
                      <b-input-group size="sm">
                        <b-form-input
                          id="filter-input"
                          v-model="filter"
                          type="search"
                          placeholder="Type to Search"
                        ></b-form-input>

                        <b-input-group-append>
                          <base-button
                            tag="a"
                            class="mb-3 mb-sm-0"
                            type="warning"
                            textColor="white"
                            icon="fa fa-reset"
                            :disabled="!filter"
                            @click="filter = ''"
                          >Clear</base-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-table
                  :bordered="true"
                  :small="true"
                  :hover="true"
                  :items="items"
                  :fields="fields"
                  :head-variant="'light'"
                  :busy.sync="isBusy"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :responsive="true"
                  :filter="filter"
                  @filtered="onFiltered"
                >
                  <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                      <pulse-loader :loading="isBusy" :color="'#d7f6e8'"></pulse-loader>
                      <strong>Loading...</strong>
                    </div>
                  </template>
                  <template #cell(actions)="row">
                    <div v-if="loading">
                      <i class="fa fa-spinner spin"></i>
                    </div>
                    <div v-else>
                      <button
                        size="sm"
                        variant="success"
                        style="cursor: pointer"
                        @click="send(row.item)"
                      >
                        <i class="fa fa-send"></i> Kirim SPTPD
                      </button>
                      <button
                        v-if="row.item.status != 'done_payment'"
                        size="sm"
                        variant="success"
                        style="cursor: pointer"
                        @click="print(row.item)"
                      >
                        <i class="fa fa-print"></i> Kode Bayar
                      </button>
                      <button
                        size="sm"
                        variant="success"
                        style="cursor: pointer"
                        @click="printSptpd(row.item)"
                      >
                        <i class="fa fa-print"></i> SPTPD
                      </button>
                      <button
                        v-if="row.item.status != 'done_payment'"
                        size="sm"
                        variant="success"
                        style="cursor: pointer"
                        @click="edit(row.item)"
                      >
                        <i class="fa fa-pencil"></i> Edit
                      </button>
                    </div>
                  </template>
                </b-table>
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  aria-controls="my-table"
                ></b-pagination>
              </card>
            </div>
          </div>
        </div>
      </div>
    </section>
    <esptpd ref="modal-e-sptpd" title="E-sptpd Pajak Mineral Bukan Logam" code="1111" @resetTable="getItems"></esptpd>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import axios from "axios";
import {
  BTable,
  BTr,
  BTh,
  BPagination,
  BRow,
  BCol,
  BInputGroup,
  BFormGroup,
  BInputGroupAppend,
  BFormInput,
  BButton,
} from "bootstrap-vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import Esptpd from "../sptpd/e-sptpd";
export default {
  name: "penerangan-jalan",
  components: {
    BTable,
    BTr,
    BTh,
    PulseLoader,
    Esptpd,
    BPagination,
    BRow,
    BCol,
    BInputGroup,
    BFormGroup,
    BInputGroupAppend,
    BFormInput,
    BButton,
  },
  data() {
    return {
      filter: "",
      sortBy: "collection_number",
      sortDesc: true,
      perPage: 10,
      currentPage: 1,
      totalRows: 0,
      loading: false,
      isBusy: false,
      items: [],
      fields: [
        {
          key: "collection_year",
          sortable: false,
          label: "Thn. SPT",
          class: "text-center",
          sortByFormatted: false,
          thClass: "text-center",
        },
        {
          key: "collection_number",
          sortable: false,
          label: "No. Pendataan",
          class: "text-center",
          thClass: "text-center",
        },
        {
          key: "start_period",
          sortable: false,
          label: "Periode",
          class: "text-center",
          thClass: "text-center",
        },
        {
          key: "registration.npwpd",
          sortable: false,
          label: "NPWPD",
          class: "text-center",
          thClass: "text-center",
        },
        {
          key: "registration.business_name",
          sortable: false,
          label: "Nama Usaha",
          class: "text-left",
          thClass: "text-center",
        },
        {
          key: "tax.name",
          sortable: false,
          label: "Jenis Pajak",
          class: "text-left",
          thClass: "text-center",
        },
        {
          key: "status",
          sortable: false,
          label: "Status",
          class: "text-center",
          thClass: "text-center",
        },
        { key: "actions", label: "Aksi" },
      ],
      timer: "",
    };
  },
  created() {
    this.getItems();
    this.timer = setInterval(this.getItems, 200000);
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    newRegister() {
      this.$refs["modal-e-sptpd"].showModal();
    },
    edit(items) {
      this.$refs["modal-e-sptpd"].showModal();
      this.$refs["modal-e-sptpd"].updateMode(items);
    },
    send(items) {
      try {
        const me = this;
        this.loading = true;

        axios({
          url: "/api/v1/collection_taxes/print_sptpd" + "?id=" + items.id,
          method: "GET",
          responseType: "blob",
        })
          .then((response) => {
            axios({
              url: "/api/v1/collection_taxes/send_sptpd" + "?id=" + items.id,
              method: "GET",
              responseType: "json",
            })
              .then((response) => {
                Swal.fire({
                  title: "",
                  html:
                    "Kirim email berhasil.<br>Silahkan cek inbox atau spam email Anda.<br><br>Terima kasih.",
                  icon: "success",
                  showCancelButton: false,
                  confirmButtonColor: "#3085d6",
                  confirmButtonText: "Tutup!",
                });
                this.loading = false;
              })
              .catch((e) => {
                // console.log(e);
                this.loading = false;
              });
          })
          .catch((e) => {
            // console.log(e);
            this.loading = false;
          });
      } catch (e) {
        // console.log(e);
        this.loading = false;
      }
    },
    print(items) {
      try {
        const me = this;
        this.loading = true;
        axios({
          url: "/api/v1/collection_taxes/print_payment" + "?id=" + items.id,
          method: "GET",
          responseType: "blob",
        })
          .then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute(
              "download",
              "Kode_Bayar_" +
                items.collection_year +
                "_" +
                items.collection_number +
                ".pdf"
            );
            document.body.appendChild(fileLink);
            fileLink.click();
            this.loading = false;
          })
          .catch((e) => {
            // console.log(e);
            this.loading = false;
          });
      } catch (e) {
        // console.log(e);
        this.loading = false;
      }
    },
    printSptpd(items) {
      try {
        const me = this;
        this.loading = true;
        axios({
          url: "/api/v1/collection_taxes/print_sptpd" + "?id=" + items.id,
          method: "GET",
          responseType: "blob",
        })
          .then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute(
              "download",
              "SPTPD_" +
                items.collection_year +
                "_" +
                items.collection_number +
                ".pdf"
            );
            document.body.appendChild(fileLink);
            fileLink.click();
            this.loading = false;
          })
          .catch((e) => {
            // console.log(e);
            this.loading = false;
          });
      } catch (e) {
        // console.log(e);
        this.loading = false;
      }
    },
    async getItems() {
      this.items = [];
      this.isBusy = true;
      try {
        let { data } = await axios.get("/api/v1/collection_taxes?code=1111");
        this.items = data;
        this.totalRows = this.items.length;
      } catch (error) {
        // console.log(error);
      } finally {
        this.isBusy = false;
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>
<style lang="scss" scoped>
.section-shaped .shape.shape-skew + .shape-container {
  padding-top: 9rem;
  padding-bottom: 14rem;
}

.card {
  width: 100% !important;
}
</style>